module.exports = __webpack_public_path__ + "static/media/94140009-FKQ0wSgs.67c700e1.JPG";